import { SEARCH_PLACE_TYPES } from '@web-platform/shared-universal-constants/src/places';

import type { SearchPlace } from '@web-platform/shared-universal-types/src/context';
import type { SearchPlaceType } from '@web-platform/shared-universal-types/src/requestContext';

export const getPlaceType = (place: SearchPlace): SearchPlaceType => {
  const { cityId, countryId, id, type } = place;

  if (type === SEARCH_PLACE_TYPES.EVERYWHERE) {
    return SEARCH_PLACE_TYPES.EVERYWHERE;
  }

  switch (id) {
    case cityId:
      return SEARCH_PLACE_TYPES.CITY;

    case countryId:
      return SEARCH_PLACE_TYPES.NATION;

    default:
      return SEARCH_PLACE_TYPES.AIRPORT;
  }
};
